/* eslint @typescript-eslint/ban-ts-ignore: 0 */

import React from 'react'
import styles from './SeekBar.module.scss'
import { SeekBarProps, SeekBarState } from './types'
import mouseDrag$ from './mouseDrag$'
import { share } from 'rxjs/operators'

class SeekBar extends React.Component<SeekBarProps, SeekBarState> {

  private _ID = 'player-control-seek'
  private _seeking = false
  private _sharedMouseDrag$
  private _dragEventSubscription
  private _subscriber
  private _seekRef

  seekRefCallback = node => {

    this._seekRef = node

  }

  state = {
    hoverScale: 0,
    progress: 0
  }

  componentDidMount () {

    this._sharedMouseDrag$ = mouseDrag$(this._seekRef).pipe(share())
    if (this.props.subscriber) {

      // @ts-ignore
      this.props.subscriber(this._sharedMouseDrag$)

    }
    this._dragEventSubscription = this._sharedMouseDrag$.subscribe({
      next: this.seekMouseMove,
      error: this.seekError
    }
    )

  }

  componentWillUnmount () {

    this._dragEventSubscription.unsubscribe()

  }

  componentDidUpdate (prevProps) {

    if (!this._seeking && this.props.progress !== prevProps.progress) {

      this.setProgress(this.props.progress)

    }

    if (this.props.subscriber && this.props.subscriber !== prevProps.subscriber) {

      // @ts-ignore
      this.props.subscriber(this._sharedMouseDrag$)

    }

  }

  componentDidCatch (e) {

    console.log('Seek bar: caught error', e)

  }

  seekError = () => {}

  private seekMouseMove = event => {

    if (event.type === 'seekComplete') {

      this._seeking = false

    }
    else {

      if (!this._seeking) this._seeking = true

    }

  }

  private updateHoverDisplay = event => {

    const { clientWidth } = event.target
    const { offsetX } = event.nativeEvent

    this.setState({ hoverScale: offsetX / clientWidth })
    if (this._seeking) this.setProgress(offsetX / clientWidth)

  }

  private resetHoverDisplay = event => {

    this.setState({ hoverScale: 0 })

  }

  private setProgress = progress => {

    this.setState({ progress })

  }

  render () {

    return <div
      className={styles['SeekBar-container']}
      data-bdd={`${this._ID}-bar`}
      ref={this.seekRefCallback}
      onMouseMove={this.updateHoverDisplay}
      onMouseOut={this.resetHoverDisplay}
    >
      <div
        className={styles['SeekBar-track']}
        data-bdd={`${this._ID}-track`}
        style={{ pointerEvents: 'none' }}
      >
        <div
          className={styles['SeekBar-hover']}
          data-bdd={`${this._ID}-hover`}
          style={{ pointerEvents: 'none',
            transform: `scaleX(${this.state.hoverScale})` }}
        > </div>
        <div
          className={styles['SeekBar-progress']}
          data-bdd={`${this._ID}-progress`}
          style={{ pointerEvents: 'none',
            transform: `scaleX(${this.state.progress})` }}
        > </div>
      </div>
    </div>

  }

}

export default SeekBar
